/* PAYMENT_INFO */
export const GET_PAYMENT_INFO = "GET_PAYMENT_INFO"
export const GET_PAYMENT_INFO_SUCCESS = "GET_PAYMENT_INFO_SUCCESS"
export const GET_PAYMENT_INFO_FAIL = "GET_PAYMENT_INFO_FAIL"